"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterBarState = void 0;
var tslib_1 = require("tslib");
var react_1 = require("react");
var useRowsCalculator_1 = require("./useRowsCalculator");
var model_1 = require("../../../../model");
//NOTE: This 1px is size of border bottom on filter bar
var BorderWidth = 1;
//NOTE: This must be same value as $transition-length
var TransitionLength = 200;
function useFilterBarState() {
    var _a = tslib_1.__read(react_1.useState(useRowsCalculator_1.CalculatedRowsDefault), 2), calculatedRows = _a[0], setCalculatedRows = _a[1];
    var expandedHeight = calculatedRows.expandedHeight, collapsedHeight = calculatedRows.collapsedHeight, rows = calculatedRows.rows;
    var dispatch = model_1.useDashboardDispatch();
    var isFilterBarExpanded = model_1.useDashboardSelector(model_1.selectFilterBarExpanded);
    var scrollable = useScrollable(isFilterBarExpanded);
    var setFilterBarExpanded = function (isExpanded) {
        return dispatch(model_1.uiActions.setFilterBarExpanded(isExpanded));
    };
    var innerHeight = isFilterBarExpanded ? expandedHeight : collapsedHeight;
    return {
        rows: rows,
        scrollable: scrollable,
        height: innerHeight + BorderWidth,
        isFilterBarExpanded: isFilterBarExpanded,
        setCalculatedRows: setCalculatedRows,
        setFilterBarExpanded: setFilterBarExpanded,
    };
}
exports.useFilterBarState = useFilterBarState;
function useScrollable(expanded) {
    var _a = tslib_1.__read(react_1.useState(false), 2), scrollable = _a[0], setScrollable = _a[1];
    react_1.useEffect(function () {
        var timer = null;
        if (expanded) {
            timer = window.setTimeout(function () { return setScrollable(true); }, TransitionLength);
        }
        else {
            setScrollable(false);
        }
        return function () {
            if (timer !== null) {
                window.clearTimeout(timer);
            }
        };
    }, [expanded]);
    return scrollable;
}
//# sourceMappingURL=useFilterBarState.js.map